module.exports = __webpack_public_path__ + "img/aws.c7401f52.png";